/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Activity_Status_ClosedInputs */

const vi_work_activity_status_closed = /** @type {(inputs: Work_Activity_Status_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đóng`)
};

/**

* @param {Work_Activity_Status_ClosedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const work_activity_status_closed = /** @type {((inputs?: Work_Activity_Status_ClosedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Activity_Status_ClosedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_work_activity_status_closed(inputs)
});